<template>
  <div class="result" :class="['food-type-' + foodType]" v-if="data">
    <img class="food-type-flag" :src="flagData[foodType].image" alt="" />
    <div class="food-top">
      <div class="flag">
        <img
          class="icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a680151c1f11349ad7c4dac84e006bd.png"
          alt=""
        />
        <div
          ><span class="equel">≈</span
          ><span class="kcal">{{ data.kcal }}</span></div
        >
        <div class="unit">kcal/份</div>
        <div class="collect-c" @click="bindCollect">
          <img class="collect" :src="collectImageUrl" alt="" />
          <div class="collect-num">{{
            data.collect_info && data.collect_info.collect_num
          }}</div>
        </div>
      </div>
      <div class="food-border">
        <img class="food-image" :src="filterUrl(data.foodImage)" alt="" />
      </div>
      <div class="food-name">{{ data.foodName }}</div>
      <div class="tips" v-if="foodType == 0"
        >*外卖(非饮品)油多建议使用吸油纸</div
      >
      <div class="desc-content">
        <div class="food-desc" :class="{ 'food-desc-line5': foodType == 0 }"
          >{{ data.recommend_desc || data.desc }}
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="b-left">
        <div
          class="avatar"
          @click="bindClickStar"
          v-buried
          data-buried="BG_JTCSM_YYSZY"
          v-clickBuried
          data-click-buried="CLICK_JTCSM_YYSZY"
        >
          <img
            class="avatar-image"
            :src="data.coachInfo && data.coachInfo.head_portrait"
            alt=""
          />
          <img
            class="avatar-flag"
            :src="data.coachInfo && data.coachInfo.icon"
            alt=""
          />
        </div>
        <div>
          <div class="text-1">{{
            data.coachInfo && data.coachInfo.expert_name
          }}</div>
          <div class="text-2">{{ data.coachInfo && data.coachInfo.alias }}</div>
        </div>
      </div>
      <div class="b-right" v-if="show">
        <!-- <img
          class="takeaway"
          v-if="(data.is_allow_takeaway || data.jump_hema) && foodType == 0"
          @click="bindShowOrder"
          v-buried
          :data-buried="'BG_EATWHAT_WAIMAI_BTN_' + data.id"
          v-clickBuried
          :data-click-buried="'CLICK_EATWHAT_WAIMAI_BTN_' + data.id"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1aaa5ca06630017e48f5eca624b375d4.png"
          alt=""
        /> -->
        <div
          class="takeaway"
          v-if="(data.is_allow_takeaway || data.jump_hema) && foodType == 0"
          @click="bindShowOrder"
          v-buried
          :data-buried="'BG_EATWHAT_WAIMAI_BTN_' + data.id"
          v-clickBuried
          :data-click-buried="'CLICK_EATWHAT_WAIMAI_BTN_' + data.id"
        >
          <div
            class="icon-list"
            :class="{ 'icon-list-one': iconList.length == 1 }"
          >
            <img
              class="icon-item"
              v-for="(item, index) in iconList"
              :key="index"
              :src="item"
              alt=""
            />
          </div>
          <div>去点外卖<span class="iconfont icon-you"></span></div>
        </div>
        <img
          class="buy"
          v-else-if="foodType == 2 && data.is_goods"
          v-buried
          :data-buried="'BG_EATWHAT_BUY_BTN_' + data.id"
          v-clickBuried
          :data-click-buried="'CLICK_EATWHAT_BUY_BTN_' + data.id"
          @click="bindBuy"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f09b77049300a3cbd35af59a80c8f06f.png"
          alt=""
        />
        <img
          class="detail"
          v-else
          @click="bindJumpDetail"
          v-buried
          :data-buried="
            'BG_EATWHAT_' + flagData[foodType].type + '_DETAIL_BTN_' + data.id
          "
          v-clickBuried
          :data-click-buried="
            'CLICK_EATWHAT_' +
            flagData[foodType].type +
            '_DETAIL_BTN_' +
            data.id
          "
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0c69bdafd30d95d1133aefcbe53f95a4.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    foodType: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      flagData: {
        0: {
          type: 'WAIMAI',
          name: '外卖',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/21e2f142854a5f5622a12c619dbebc5b.png'
        },
        1: {
          type: 'ZIZHI',
          name: '自制',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/06f18d62b67a021c297c53d464d9e2ea.png'
        },
        2: {
          type: 'LINGSHI',
          name: '零食',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ad4aa707f4d7afba20db4cf7a37e91b2.png'
        }
      }
    }
  },
  computed: {
    collectImageUrl() {
      return this.data?.collect_info?.is_collect
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/762d32b08bd955a6d856dab74f0ad57e.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/238311191b2ef765ebf8104f14406a78.png'
    },
    //按钮图标列表
    iconList() {
      let list = []
      if (this.data.jump_hema) {
        list.push(
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c68243ac27cf4e4c56b71d347e384c1e.png'
        )
      }
      if (this.data.is_allow_takeaway) {
        list.push(
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/13c0c2839473c15ccdf34eeed899fa2d.png',
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7c292d34540f52de7548b4991b07c737.png'
        )
      }
      return list
    }
  },
  created() {},
  methods: {
    bindCollect() {
      if (!this.$http._isApp()) {
        return
      }
      let collect =
        (this.data.collect_info && this.data.collect_info.is_collect) || 0
      let num =
        (this.data.collect_info && this.data.collect_info.collect_num) || 0
      let params = {
        collect_type: this.foodType == 2 ? 1 : 0,
        content_id: this.data.id,
        is_collect: +!collect
      }
      this.$http
        .postBaseApp('member/Collect/operateCollect', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.collect_info.is_collect = !collect
            let tips = ''
            if (collect) {
              this.data.collect_info.collect_num = num - 1 < 0 ? 0 : num - 1
              tips = '已取消收藏'
            } else {
              this.data.collect_info.collect_num = num + 1
              tips = '收藏成功'
            }
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
        })
    },
    filterUrl(url) {
      if (url) {
        url = url + '?x-oss-process=image/resize,w_272/quality,Q_100'
      }
      return url
    },
    bindShowOrder() {
      this.$emit('order')
    },
    bindBuy() {
      if (this.data.jump_url) {
        if (this.data.jump_type == 1) {
          this.$betterwe.jumpWmStore(this.data.jump_url)
        } else if (this.data.jump_type == 2) {
          this.$betterwe.jumpRoute(this.data.jump_url)
        }
      }
    },
    bindJumpDetail() {
      switch (this.data.foodType) {
        case 1:
          this.jumpSuperMealDetail(this.data.id)
          break
        case 2:
          this.jumpFoodDetail(this.data.id)
          break
        case 3:
          this.jumpSuperFoodDetail(this.data.id)
          break
      }
    },
    //跳转达人或者明星营养师详情
    bindClickStar() {
      if (this.data.coachInfo.jump_url) {
        this.$betterwe.jumpRoute(this.data.coachInfo.jump_url)
      }
    },
    //超级菜谱详情
    jumpSuperMealDetail(id) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute('/recipeDetails?id=' + id)
      }
    },
    //普通食物详情
    jumpFoodDetail(id) {
      this.$router.push({
        path: '/calorie-query/food-info',
        query: {
          foodid: id
        }
      })
    },
    //超级食物详情
    jumpSuperFoodDetail(id) {
      this.$router.push({
        path: '/calorie-query/super-food-detail',
        query: {
          id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  padding: 12px 12px 10px;
  background: linear-gradient(180deg, #fce449 0%, #fdde18 74%, #ffc669 100%);
  box-shadow: 0px 1px 12px 0px rgba(76, 88, 100, 0.2);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .food-type-flag {
    position: absolute;
    left: -1px;
    top: -1px;
    z-index: 1;
    width: 114px;
    height: 32px;
    object-fit: contain;
  }

  .food-top {
    flex: 1;
    flex-shrink: 0;
    padding: 16px 13px;
    box-sizing: border-box;
    margin-bottom: 20px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 1px 12px 0px rgba(76, 88, 100, 0.2);
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;

    .flag {
      position: absolute;
      right: 8px;
      top: 8px;
      padding: 3px 3px 10px;
      background: #ffffff;
      border-radius: 26px;
      border: 1px solid #f2eeff;
      text-align: center;
      font-weight: bold;
      font-family: Helvetica-Bold, Helvetica;
      color: rgba(0, 0, 0, 0.6);
      line-height: 13px;
      text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);

      .icon {
        width: 42px;
        height: 30px;
        object-fit: contain;
        margin-bottom: 6px;
      }

      .equel {
        font-size: 9px;
        font-weight: 600;
      }

      .kcal {
        font-size: 17px;
        margin-bottom: 2px;
      }

      .unit {
        line-height: 13px;
        font-size: 10px;
      }

      .collect-c {
        margin-top: 6px;
        border-top: 1px solid #f2eeff;
      }

      .collect {
        margin: 0 auto;
        margin-top: 6px;
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      .collect-num {
        margin-top: 2px;
        font-size: 10px;
      }
    }

    .food-border {
      margin: 0 auto;
      margin-bottom: 8px;
      width: 156px;
      height: 156px;
      box-sizing: border-box;
      overflow: hidden;
      border-radius: 50%;
      border: 10px solid #fff;
      box-shadow: 0px 2px 6px rgba(163, 163, 163, 0.21);

      .food-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .food-name {
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);
      margin-bottom: 8px;
    }

    .tips {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffa24f;
      line-height: 20px;
      text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);
      margin-bottom: 4px;
    }

    .desc-content {
      text-align: center;
    }

    .food-desc {
      display: -webkit-inline-box;
      text-align: left;
      font-size: 12px;
      word-break: break-all;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }

    .food-desc-line5 {
      -webkit-line-clamp: 4;
    }
  }

  .food-top::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    left: 36px;
    top: 100%;
    transform: translate(0%, -9px);
    border-top: 9px solid transparent;
    border-bottom: 9px solid transparent;
    border-left: 15px solid rgb(255, 251, 237);
    border-right: 0px solid transparent;
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .b-left {
      display: flex;
      align-items: center;

      .avatar {
        position: relative;
        width: 34px;
        height: 33px;
        margin-right: 6px;

        .avatar-image {
          width: 100%;
          height: 100%;
          border-radius: 6px;
          overflow: hidden;
          object-fit: cover;
        }

        .avatar-flag {
          width: 13px;
          height: 13px;
          position: absolute;
          bottom: 0;
          right: -1px;
        }
      }

      .text-1 {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
        text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);
      }

      .text-2 {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
        text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);
      }
    }

    .b-right {
      .takeaway {
        display: flex;
        align-items: center;
        height: 31px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 16px;
        padding: 0px 9px;
        font-weight: bold;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 14px;
        .icon-list {
          display: flex;
          align-items: center;
          margin-right: 5px;
          .icon-item {
            width: 15px;
            height: 15px;
            margin-left: -4px;
          }
          .icon-item:first-child {
            margin-left: 0;
          }
        }
        .icon-list-one {
          .icon-item {
            width: 20px;
            height: 20px;
          }
        }
        .iconfont {
          color: rgba(0, 0, 0, 0.7);
        }
      }

      .buy {
        width: 90px;
        height: 31px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px 1px 12px 0px rgba(76, 88, 100, 0.2);
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 14px;
        text-shadow: 0px 1px 12px rgba(76, 88, 100, 0.2);

        .iconfont {
          width: 4px;
        }
      }

      .detail {
        width: 90px;
        height: 31px;
        object-fit: contain;
      }
    }
  }
}

.food-type-0 {
  background: linear-gradient(180deg, #fce449 0%, #fdde18 74%, #ffc669 100%);

  .food-name {
    margin-bottom: 2px !important;
  }

  .food-top::after {
    border-left: 15px solid rgb(255, 251, 237);
  }
}

.food-type-1 {
  background: linear-gradient(189deg, #9cf1ff 0%, #72d4f1 100%);

  .food-top::after {
    border-left: 15px solid rgb(242, 251, 254);
  }
}

.food-type-2 {
  background: linear-gradient(182deg, #8cedb0 0%, #6bdb97 100%);

  .food-top::after {
    border-left: 15px solid rgb(242, 252, 246);
  }
}
</style>
